import { CloseCookiePoliceIcon } from 'assets/svg'
import { COOKIES_POLICY_KEY } from 'constants/variables'
import { Link } from 'gatsby'
import Cookies from 'js-cookie'
import React, { FC, useCallback } from 'react'
import { ToastContentProps } from 'react-toastify'
import styled from 'styled-components'
import Button from 'ui/Button'

const CookiesPoliceToast: FC<ToastContentProps<any>> = ({ closeToast }) => {
  const handleSubmit = useCallback(() => {
    closeToast && closeToast()
    Cookies.set(COOKIES_POLICY_KEY, 'accepted')
  }, [closeToast])

  return (
    <Container>
      <CloseButton onClick={() => closeToast && closeToast()}>
        <CloseCookiePoliceIcon />
      </CloseButton>
      <Content>
        <Text>
          This site uses cookies. By clicking <GotIt>&quot;got it&quot;</GotIt> or continuing to browse the site you are
          agreeing to our use of cookies. <StyledLink to='/cookie-policy'>More info</StyledLink>
        </Text>
        <SubmitButton onClick={handleSubmit}>Got it</SubmitButton>
      </Content>
    </Container>
  )
}

export default CookiesPoliceToast

const Container = styled.div`
  width: 100%;
  max-width: 650px;
  position: relative;
  padding: 19px 40px 19px 30px;
  border: 1px solid ${({ theme: { colors } }) => colors.border};
  border-radius: 4px;
  background: ${({ theme: { colors } }) => colors.white};

  @media ${({ theme }) => theme.device.mobile} {
    padding-inline-start: 20px;
    width: 100vw;
  }
`

const CloseButton = styled(Button)`
  position: absolute;
  top: 10px;
  right: 10px;
  width: 18px;
  height: 18px;
`
const Content = styled.div`
  display: flex;
  align-items: center;
  gap: 37px;

  @media ${({ theme }) => theme.device.mobile} {
    gap: 15px;
  }
`
const Text = styled.div`
  max-width: 425px;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  color: ${({ theme: { colors } }) => colors.default};

  @media ${({ theme }) => theme.device.mobile} {
    font-size: 10px;
    line-height: 16px;
  }
`

const GotIt = styled(Text)`
  font-weight: 600;
  display: inline;
`

const StyledLink = styled(Link)`
  color: ${({ theme: { colors } }) => colors.link};
  text-decoration: underline;
`
const SubmitButton = styled(Button)`
  padding: 15px 35px;
  font-weight: 700;
  font-size: 12px;
  line-height: 16px;
  display: flex;
  align-items: center;
  text-align: center;
  text-transform: uppercase;
  color: ${({ theme: { colors } }) => colors.white};
  background: ${({ theme: { colors } }) => colors.link};
  border-radius: 4px;
  white-space: nowrap;

  @media ${({ theme }) => theme.device.mobile} {
    padding: 8px 16px;
  }
`
